import { Component, input, model, output } from "@angular/core";
import { WindowState } from "@progress/kendo-angular-dialog";
import { KENDO_ICONS, ICON_SETTINGS } from "@progress/kendo-angular-icons";
import {
  xIcon,
  windowMinimizeIcon,
  windowIcon,
  windowRestoreIcon,
} from "@progress/kendo-svg-icons";

@Component({
  selector: "app-window-titlebar",
  imports: [KENDO_ICONS],
  providers: [{ provide: ICON_SETTINGS, useValue: { type: "svg" } }],
  templateUrl: "./window-titlebar.component.html",
  styles: `
    :host {
      display: flex;
      flex: 1;
      align-items: center;
      width: 100%;
    }
    .k-window-title {
      flex: 1;
    }
  `,
})
export class WindowTitlebarComponent {
  title = input.required<string>();
  state = model.required<WindowState>();
  closeWindow = output<void>();

  protected readonly xIcon = xIcon;
  protected readonly windowMinimizeIcon = windowMinimizeIcon;
  protected readonly windowIcon = windowIcon;
  protected readonly windowRestoreIcon = windowRestoreIcon;

  toggleMinimize() {
    this.state.set(this.state() === "minimized" ? "default" : "minimized");
  }

  toggleMaximize() {
    this.state.set(this.state() === "maximized" ? "default" : "maximized");
  }

  onClose() {
    this.closeWindow.emit();
  }
}
